<template>
    <div class="flex flex-col justify-center space-y-32">
        <application-sources
            ref="applicationSourcesGraph"
            :filter-fields="filterFields"
            :class="defaultCardClasses"
        ></application-sources>
        <interim-applications
            ref="interimApplicationsGraph"
            :filter-fields="filterFields"
            :class="defaultCardClasses"
        />
    </div>
</template>

<script>
import ApplicationSources from './ApplicationSources';
import InterimApplications from "./InterimApplications.vue";

export default {
    name: 'TabResources',
    components: {
        InterimApplications,
        ApplicationSources,
    },
    props: {
        filterFields: {type: Object},
        defaultCardClasses: {type: String},
    },
}
</script>
